module.exports = __webpack_public_path__ + "assets/img/vrkc_dt_center.633abc94.png";